import React from "react";
import { FontStyle, Inputs } from "../constants";

const FettiInput = ({ extraStyle = null, ...props }) => {
  return (
    <input
      style={{
        ...FontStyle.body,
        borderRadius: Inputs.borderRadius,
        border: "1px solid #222",
        // border: "1px solid #000",
        padding: `${Inputs.py} ${Inputs.px}`,
        fontSize: "16px",
        width: "100%",
        ...extraStyle,
      }}
      {...props}
    />
  );
};

export default FettiInput;
